import { Loading } from '@components/Loading'
import React from 'react'

export interface LoadingGateProps {
  isLoading: boolean
  children: React.ReactNode
}

const LoadingGate = ({ isLoading, children }: LoadingGateProps) => {
  return (
    <div className='w-full'>
      {isLoading ? (
        <div className='flex justify-center items-center'>
          <Loading />
        </div>
      ) : (
        children
      )}
    </div>
  )
}

export default LoadingGate
